import { clsx } from 'clsx';
import dayjs from 'dayjs';
import { twMerge } from 'tailwind-merge';
export function cn() {
  for (var _len = arguments.length, inputs = new Array(_len), _key = 0; _key < _len; _key++) {
    inputs[_key] = arguments[_key];
  }
  return twMerge(clsx(inputs));
}
export function isHexColor(color) {
  if (!color) return false;
  return /^#[0-9A-F]{6}$/i.test(color);
}
export function opacityColorByPercent(color, percent) {
  if (!isHexColor(color)) return color;
  var opacity = Math.round(percent * 255);
  return "".concat(color).concat(opacity.toString(16).toUpperCase());
}
export function getValues(vals, defaultVal) {
  var index = vals.findIndex(function (v) {
    return v !== undefined && v !== null;
  });
  if (index === -1) return defaultVal;
  return vals[index];
}
export function logVersion() {
  if (typeof window !== 'undefined') {
    window.__moly__ = {
      dt: dayjs().format(),
      v: '1.0.0-beta.202'
    };
  }
}